import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'vui-form-group',
    templateUrl: './form-group.component.html',
    styleUrls: ['./form-group.component.scss']
})
export class FormGroupComponent implements OnInit {
    @Input() public description: string;
    @Input() public title: string;

    constructor() {
    }

    ngOnInit() {
    }

}
